(() => {
  if (window.__HausielCartStabilityInstalled) return;
  window.__HausielCartStabilityInstalled = true;

  // The global polish stylesheet previously hid every drawer upsell card from
  // the third onward. Keep all four ranked cards visible in the cart drawer.
  if (!document.getElementById('HausielCartFourCardsVisibilityFix')) {
    const style = document.createElement('style');
    style.id = 'HausielCartFourCardsVisibilityFix';
    style.textContent = `cart-drawer .hausiel-drawer-upsell__cards .hausiel-drawer-upsell__card:nth-child(n+3){display:grid!important}`;
    document.head.appendChild(style);
  }

  customElements.whenDefined('cart-drawer').then(() => {
    const CartDrawerElement = customElements.get('cart-drawer');
    const proto = CartDrawerElement?.prototype;
    if (!proto || proto.__hausielStabilityPatched) return;
    proto.__hausielStabilityPatched = true;

    const baseSchedule = proto.scheduleHausielUpdate;
    if (typeof baseSchedule === 'function') {
      proto.scheduleHausielUpdate = function (attempt = 0) {
        if (attempt === 0) {
          clearTimeout(this.hausielProductRetryTimer);
          this.hausielProductRetryTimer = null;
          this.hausielProductFailureRetries = 0;
          this.hausielGeneration = Number(this.hausielGeneration || 0) + 1;
        }
        return baseSchedule.call(this, attempt);
      };
    }

    proto.loadProducts = function () {
      if (!this.hausielProductsPromise) {
        let request;
        request = fetch('/collections/ev-yasam/products.json?limit=50', {
          headers: { Accept: 'application/json' },
        })
          .then((response) =>
            response.ok ? response.json() : Promise.reject(new Error('Products unavailable'))
          )
          .then((payload) => {
            this.hausielProductFailureRetries = 0;
            return Array.isArray(payload?.products) ? payload.products : [];
          })
          .catch((error) => {
            if (this.hausielProductsPromise === request) this.hausielProductsPromise = null;

            if (
              typeof baseSchedule === 'function' &&
              Number(this.hausielProductFailureRetries || 0) < 1
            ) {
              this.hausielProductFailureRetries = Number(this.hausielProductFailureRetries || 0) + 1;
              clearTimeout(this.hausielProductRetryTimer);
              this.hausielProductRetryTimer = setTimeout(() => {
                this.hausielProductRetryTimer = null;
                if (this.isConnected && !this.classList.contains('is-empty')) {
                  baseSchedule.call(this, 0);
                }
              }, 180);
            }

            throw error;
          });

        this.hausielProductsPromise = request;
      }

      return this.hausielProductsPromise;
    };
  });
})();
